import React from 'react';

import ModifierSelect from './modifier-select';
import OneSelect from './one-select';
import QuantityStepper from './quantity-stepper';
import YesNoCheckbox from './yes-no-checkbox';

const OptionPickerByFormCode = ({
  category,
  categoryKeyPath,
  formCode,
  productOption,
  topLevelCategoryName,
  topLevelCategoryNumber,
  useInactiveStyle,
}) => {
  if (formCode === 'one') {
    return (
      <OneSelect
        categoryKeyPath={categoryKeyPath}
        key={productOption.productNumber}
        productOptionCategory={category}
        topLevelCategoryName={topLevelCategoryName}
        topLevelCategoryNumber={topLevelCategoryNumber}
        useInactiveStyle={useInactiveStyle}
      />
    );
  }

  if (formCode === 'modifier') {
    return (
      <ModifierSelect
        categoryKeyPath={categoryKeyPath}
        key={productOption.productNumber}
        productOptionForm={productOption.form}
        productOptionNumber={productOption.productNumber}
        topLevelCategoryName={topLevelCategoryName}
        topLevelCategoryNumber={topLevelCategoryNumber}
        useInactiveStyle={useInactiveStyle}
      />
    );
  }

  if (formCode === 'qty') {
    return (
      <QuantityStepper
        categoryKeyPath={categoryKeyPath}
        key={productOption.productNumber}
        productOptionCategory={category}
        productOptionForm={productOption.form}
        productOptionNumber={productOption.productNumber}
        topLevelCategoryName={topLevelCategoryName}
        topLevelCategoryNumber={topLevelCategoryNumber}
        useInactiveStyle={useInactiveStyle}
      />
    );
  }

  if (formCode === 'yes-no') {
    return (
      <YesNoCheckbox
        categoryKeyPath={categoryKeyPath}
        productOption={productOption}
        topLevelCategoryName={topLevelCategoryName}
        topLevelCategoryNumber={topLevelCategoryNumber}
      />
    );
  }
};

export default OptionPickerByFormCode;
